/**
 * Created by Languagenut on 13/06/2018.
 */



import React, { Component } from 'react';
import $ from 'jquery'

export default class Popup extends Component {

    constructor(props) {
        super();
        this.props = props
        this.id = Math.random().toString(36).substr(2, 9);
        this.state = {
            id:Math.random().toString(36).substr(2, 9),
        };
    }

    getSize() {
        return (window.innerWidth/4) - 20
    }

    componentDidMount(){
        if(!this.props.open && this.props.fullHeight)
        {
            // var objects = document.getElementsByClassName('popup-hide');

            //  for(var idx = 0; idx < objects.length; idx++)
            // {
            //     var obj = objects[idx];
            //     TweenMax.to(obj , 0.1 , {opacity:this.props.open ? 0 : 1})
            // }
        }

        if(!this.props.open) return;
        if(!$('.achivement-popup') ) return;
    }

    componentDidUpdate()
    {

        if(!this.props.open && this.props.fullHeight)
        {
           // var objects = document.getElementsByClassName('popup-hide');

          //  for(var idx = 0; idx < objects.length; idx++)
           // {
           //     var obj = objects[idx];
           //     TweenMax.to(obj , 0.1 , {opacity:this.props.open ? 0 : 1})
           // }
        }

        if(!this.props.open) return;
        if(!$('.achivement-popup') ) return;
    }

    componentWillReceiveProps(props) {
        this.props = props
        this.setState({update:true});



    }


    render()
    {
        var fullHeight = window.innerHeight+"px";
        if(!this.props.open) return null;

        return <div onClick={this.props.close} id={this.id} className="popupabsoulte" style={{position:"absolute" , background:"RGBA(34,34,34,0.8)" ,  height: fullHeight, width:"100%"}}>
            <div style={{overflowY:'scroll' , height: fullHeight , minHeight: fullHeight , maxHeight: fullHeight}}>

                <center id="parent" className="achivement-popup" onClick={(e) => e.stopPropagation()} >
                    <div onClick={this.props.close} className="achivement-close"><b>x</b></div>
                    {this.props.children}
                </center>
            </div>
        </div>
    }

}